var map = {
	"./0.png": "caf6",
	"./amex.png": "30b1",
	"./chip.png": "61b6",
	"./dinersclub.png": "6d12",
	"./discover.png": "8a5d",
	"./jcb.png": "3fda",
	"./mastercard.png": "bef4",
	"./troy.png": "752c",
	"./unionpay.png": "4a74",
	"./visa.png": "c552"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed26";